module.exports = __webpack_public_path__ + "static/media/i_footer_home_on.7041511d.png";